import { Shirt } from "lucide-react";

export default function DressCode({ wedding }) {
  if (!wedding.dress_code?.trim()) return null;
  return (
    <section className="py-16 sm:py-20 px-6 sm:px-12" data-testid="dress-code-section">
      <div className="max-w-xl mx-auto text-center">
        <Shirt size={28} className="mx-auto mb-4" style={{ color: "var(--wed-primary)" }} />
        <p className="eyebrow mb-3">Dress code</p>
        <p className="text-neutral-600 leading-relaxed whitespace-pre-line">{wedding.dress_code}</p>
      </div>
    </section>
  );
}
